import React from 'react';
import { connect } from 'react-redux';
import {
    Paper,
    Typography,
    Divider,
    makeStyles,
    TableHead,
    TableCell,
    TableRow,
    Table,
    TableBody,
    TableFooter,
    TablePagination,
} from '@material-ui/core';
import { getLoggedInUserSelector } from "../../state/Auth"
import { getUserFacilitiesListSelector } from "../../state/UserFacilities"
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    main: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
    },
    section: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    label: {
        fontWeight: "700",
    },
    table: {
        overflowY: "auto",
        [theme.breakpoints.down('xs')]: {
            maxHeight: theme.spacing(50),
            minWidth: theme.spacing(35),
        },
        [theme.breakpoints.up('sm')]: {
            maxHeight: theme.spacing(65),
            minWidth: theme.spacing(65),
        },
    },
}))

const Home = props => {

    const {user, facilities} = props

    const classes = useStyles();
    const [offset, setOffset] = React.useState(0)

    const limit = 10
    const count = facilities.length
    const pageEnd = offset+limit < count ? offset+limit : count
    const data = facilities.slice(offset, pageEnd)

    const paginationRow = (
        <TableRow>
            <TablePagination
             rowsPerPage={limit}
             rowsPerPageOptions={[]}
             count={count}
             page={offset/limit}
             onChangePage={(e,page)=>{setOffset(page*limit)}}
            />
        </TableRow>
    )

    return (
        <Paper elevation={6} className={classes.main}>
            <div className={classes.section}>
                <Typography variant="h4">
                    Welcome {user.username}
                </Typography>
            </div>
            <Divider />
            <div className={classes.section}>
                <Typography variant="h6">Your Facilities</Typography>
                <div className={classes.table}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.label}>Name</TableCell>
                            <TableCell className={classes.label}>Description</TableCell>
                        </TableRow>
                        {count > limit && paginationRow}
                    </TableHead>
                    <TableBody>
                        {data.map(facility => (
                            <TableRow key={facility.id}>
                                <TableCell><Link to={`/facilities/${facility.id}`}>{facility.name}</Link></TableCell>
                                <TableCell>{facility.description}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {count > limit && <TableFooter>{paginationRow}</TableFooter>}
                </Table>
                </div>
            </div>
        </Paper>
    )
}

const mapStateToProps = state => {
    const user = getLoggedInUserSelector(state)
    const facilities = getUserFacilitiesListSelector(state)
    return {user, facilities}
}

export default connect(mapStateToProps)(Home)
